export default {"src":"/_next/static/media/profile-pro.275d7585.svg","height":400,"width":400,"blurWidth":0,"blurHeight":0};